import { Outlet, useLocation } from 'react-router-dom';
import { useIsRouteHidden } from '@/brands';
import { NotFoundPage } from '@/pages/NotFoundPage';

/**
 * Menu Visibility, enforced at the router.
 *
 * Sits above the layouts the menus link into, so a page the super admin has
 * taken every link to answers 404 instead of rendering — typing the URL, an old
 * bookmark and a shared link all land in the same place the button used to be.
 *
 * A route element rather than a per-route flag because the casino lobby and the
 * sports page are single param routes standing in for six nav items each; there
 * is nothing to unmount, only a path to judge once it is known.
 *
 * `SiteGate` holds its splash until GET /brand resolves, so by the time this
 * runs the menus are the brand's real ones — no window where a hidden page
 * paints first and blinks out.
 */
export function MenuGate() {
  const { pathname } = useLocation();
  return useIsRouteHidden(pathname) ? <NotFoundPage /> : <Outlet />;
}
